import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=7f2a3585&scoped=true"
import script from "./ModuleSettings.vue?vue&type=script&lang=js"
export * from "./ModuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=7f2a3585&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a3585",
  null
  
)

export default component.exports